export const PATHS = {
  DASHBOARD: '/',
  POST_MANAGEMENT: '/posts',
  DONOR_MANAGEMENT: '/donors',
  PAYMENT_STATUS: '/payments',
  PROJECT_MANAGEMENT: '/project',
  PROJECT_SETTINGS: '/project/settings',
  NEW_PROJECT: '/project/new',
  MY_ACCOUNT: '/account',
  GIVING_ACCOUNT_APPLY: '/giving-account/apply',
  LOGIN: '/login',
  LOGIN_EMAIL: '/login/email',
  SSO_CALLBACK: '/sso/callback',
  SNS_KAKAO_CALLBACK: '/auth/kakao/callback',
  PASSWORD_FIND: '/password/find',
  DONATION_HISTORY_FIND: '/donation/find',
  SIGNUP: '/signup',
};

